import React, { Component } from "react";
import Appbar from "./appbar";
// import DemoCarousel from "../auth/carsouel";
import Image from "../Image";
export default class CommonTemplate extends Component {
  render() {
    const { title, textOne, textTwo } = this.props;
    return (
      <div className="login-container">
        <Appbar />
        <div className="login-without-appbar">
          {/* <DemoCarousel isName={title}/> */}
          <div className="login-right-div" style={{ overflowY: "scroll" }}>
            {/* <div className="login-title">{title}</div>  */}
            <div
              style={{
                display: "flex",
                justifyContent: "center",
                marginBottom: 30,
              }}
            >
              <Image
                src={"/images/kfin_dist_logo.svg"}
                alt="field_image"
                height={60}
              />
            </div>
            <div className="otp-text1">{textOne}</div>
            <div className="otp-text2">{textTwo}</div>
            {this.props.children}
          </div>
        </div>
      </div>
    );
  }
}
